export default __webpack_public_path__ + "static/media/enterpriseIp.082cbc89.svg";